import { t } from "@lingui/macro";
import { i18n } from "@lingui/core";
import { Chip, ListItemText, Stack, Typography } from "@mui/material";
import moment from "moment";
import { ApiConversionStep } from "../../../api/types";
import { DataTableColumn } from "../../dataTable";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import { getStatusColor } from "../../../helpers/getConversionStatusColoer";
import TimerDisplayText from "../../timerDisplayText";

export function stepsTableColumns(): DataTableColumn<ApiConversionStep>[] {
  return [
    {
      header: {
        id: "name",
        label: t(i18n)`NAME`,
      },
      key: "name",
      valueFormatter: (row) => (
        <ListItemText primary={row.name} secondary={row.description} />
      ),
    },
    {
      header: {
        id: "startedAt",
        label: t(i18n)`START`,
      },
      key: "startedAt",
      valueFormatter: (row) =>
        moment(row.startedAt).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      header: {
        id: "elapsedTime",
        label: t(i18n)`TIME`,
      },
      key: "elapsedTime",
      valueFormatter: (row) =>
        row.status === "Running" ? (
          <TimerDisplayText startValue={row.startedAt?.toString()} />
        ) : (
          row.elapsedTime?.split(".")[0] || ""
        ),
    },
    {
      header: {
        id: "counters_messaging_warnings",
        label: t(i18n)`WARNINGS`,
      },
      key: "counters_messaging_warnings",
      valueFormatter: (row) => (
        <Stack direction="row" spacing={1}>
          <Typography>{row.messaging.warnings}</Typography>
          <Typography>
            {row.messaging.warnings > 0 && (
              <WarningIcon
                sx={{ color: (theme) => theme.palette.warning.main }}
              />
            )}
            {row.messaging.warnings === 0 && (
              <CheckCircleIcon
                sx={{ color: (theme) => theme.palette.success.main }}
              />
            )}
          </Typography>
        </Stack>
      ),
    },
    {
      header: {
        id: "counters_messaging_errors",
        label: t(i18n)`ERRORS`,
      },
      key: "counters_messaging_errors",
      valueFormatter: (row) => (
        <Stack direction="row" spacing={1}>
          <Typography>{row.messaging.errors}</Typography>
          <Typography>
            {row.messaging.errors > 0 && (
              <ErrorIcon sx={{ color: (theme) => theme.palette.error.main }} />
            )}
            {row.messaging.errors === 0 && (
              <CheckCircleIcon
                sx={{ color: (theme) => theme.palette.success.main }}
              />
            )}
          </Typography>
        </Stack>
      ),
    },
    {
      header: {
        id: "status",
        label: t(i18n)`STATUS`,
      },
      key: "status",
      valueFormatter: (row) => (
        <Chip
          sx={{ width: 100 }}
          label={row.status.toUpperCase()}
          variant="filled"
          size="small"
          color={getStatusColor(row.status)}
        />
      ),
    },
  ];
}
